import { format } from "date-fns";
import en from "date-fns/locale/en-US";
import ja from "date-fns/locale/ja";
import { useState } from "react";

import { useGetMonths } from "./functions/useGetMonths";
import { useRegisterLocale } from "./functions/useRegisterLocale";

import type { Props } from "./props";

type Input = Props;

export const useThis = (input: Input) => {
  const { onDateSelect, selectedDate } = input;
  const { locale } = useRegisterLocale();
  const [currentDate, setCurrentDate] = useState(selectedDate ?? new Date());
  const [isMonthPicker, setIsMonthPicker] = useState(false);
  const months = useGetMonths();

  const isJaLocale = locale === "ja";

  const handleDateChange = (date: Date | null) => {
    onDateSelect(date);
  };

  const handleMonthSelect = (monthIndex: number) => {
    const newDate = new Date(currentDate.getFullYear(), monthIndex, 1);
    setCurrentDate(newDate);
    setIsMonthPicker(false);
  };

  const goToPrevYear = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear() - 1, currentDate.getMonth(), 1)
    );
  };

  const goToNextYear = () => {
    setCurrentDate(
      new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), 1)
    );
  };

  const yearFormatter = (date: Date) => {
    const currentYear = date.getFullYear();
    const suffix = isJaLocale ? "年" : "";

    return `${currentYear}${suffix}`;
  };

  const yearMonthFormatter = (date: Date) => {
    const formatCharacter = isJaLocale ? "yyyy年M月" : "MMM yyyy";
    const localeData = isJaLocale ? ja : en;
    return format(date, formatCharacter, { locale: localeData });
  };

  return {
    currentDate,
    goToNextYear,
    goToPrevYear,
    handleDateChange,
    handleMonthSelect,
    isMonthPicker,
    locale,
    months,
    setIsMonthPicker,
    yearFormatter,
    yearMonthFormatter,
  };
};
